import { environment } from './app/environments/environment';

import('MFEWidgetCore/AppConfig').then((module) =>
{	module.AppConfig.setConfig(environment);	});

import('./bootstrap').catch(err => console.error(err));
